
<template>
	<div class="volatility-return app">
		<volatility-return :widget-data="widgetData" @open-modal="openModal">
			<template #superscript1>
				<disclosure-superscript
					class="detail-page"
					anchor="volatilityTitle"
					:statistics="['NAVAvg10yr']"
				/>
			</template>
			<template #superscript2>
				<disclosure-superscript
					class="detail-page"
					anchor="standardDeviation"
					:statistics="['stdDeviation']"
				/>
			</template>
			<template #superscript3>
				<disclosure-superscript
					class="detail-page"
					anchor="volatilityPrimaryIndex"
					:statistics="[primaryIndexId]"
				/>
			</template>
			<template #standardDeviation>
				<i-ball-modal tag="SDF" />
			</template>
			<template #volatilityIndex>
				<i-ball-modal :tag="primaryIndexId" />
			</template>
		</volatility-return>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import VolatilityReturn from './volatility-return/VolatilityReturn';
export default {
	name: 'VolatilityReturnWrapper',
	components: {
		'volatility-return': VolatilityReturn
	},
	computed: {
		...mapGetters([
			'getFundAttributes',
			'volatilityData',
			'getFundInfoData'
		]),
		...mapState(['volatilityReturn']),
		widgetData() {
			const data = this.volatilityData;
			if (data && this.getFundAttributes) {
				data.classSymbol = this.getFundAttributes.FundSymbol;
				data.shareClass = this.getFundAttributes.ShareClass;
				data.objective = this.getFundAttributes.Objective;
				data.assetClass = this.getFundAttributes.AssetClass;
				if (this.getFundInfoData && data.indexData) {
					data.indexData['FundName'] =
						this.getFundInfoData &&
						this.getFundInfoData.cgIndexName;
				} else if (
					this.getFundInfoData &&
					data.equityIndexData &&
					data.fixedIncomeIndexData
				) {
					data.equityIndexData[
						'FundName'
					] = this.getFundInfoData.cgIndexName;
					data.fixedIncomeIndexData[
						'FundName'
					] = this.getFundInfoData.cgIndexName;
				}
			}
			return data;
		},
		primaryIndexId() {
			//return the primary Index Id from the data if its formatted for dual charts, or for the single chart
			return (
				(this.volatilityData &&
					this.volatilityData.equityIndexData &&
					this.volatilityData.equityIndexData.Number) ||
				(this.volatilityData &&
					this.volatilityData.fixedIncomeIndexData &&
					this.volatilityData.fixedIncomeIndexData.Number) ||
				(this.volatilityData &&
					this.volatilityData.indexData &&
					this.volatilityData.indexData.Number) ||
				''
			);
		}
	},
	methods: {
		openModal() {
			const modal = { showModal: true, activeTab: 'volatility' };
			this.$store.commit('displayModal', modal);
		}
	}
};
</script>
